export default __webpack_public_path__ + "static/media/footer.09e09715.svg";